module.exports = __webpack_public_path__ + "img/DK17200615.ed0c7463.png";